

import { AppState, SectionType, Theme } from './types';

// Check for preloaded state injected during HTML export
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const preloadedState = (window as any).__PRELOADED_STATE__ as AppState | undefined;

const HOME_WATER_IMAGES = [
  'https://images.unsplash.com/photo-1541093113199-5959d71e9a6e?q=80&w=2670&auto=format&fit=crop', // Modern Kitchen Tap
  'https://images.unsplash.com/photo-1616486338812-3dadae4b4f9d?q=80&w=2670&auto=format&fit=crop', // Minimalist interior
  'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=2670&auto=format&fit=crop', // Luxury Resort vibe
  'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2653&auto=format&fit=crop', // Modern Clean
];

export const PRESET_THEMES: Theme[] = [
  {
    id: 'theme-sand-charcoal',
    name: 'Sand & Charcoal (Quiet Luxury)',
    primaryColor: '#1f1f1f', // Soft Black
    secondaryColor: '#d6cec5', // Warm Beige
    isPreset: true,
  },
  {
    id: 'theme-olive-silk',
    name: 'Olive & Silk',
    primaryColor: '#3a3e36', // Deep Olive
    secondaryColor: '#e0ded9', // Silk White
    isPreset: true,
  },
  {
    id: 'theme-navy-gold',
    name: 'Midnight Navy',
    primaryColor: '#0f172a', // Deep Navy
    secondaryColor: '#c7b299', // Muted Gold
    isPreset: true,
  }
];

const DEFAULT_STATE: AppState = {
  isEditMode: false,
  viewMode: 'admin',
  currentThemeId: 'theme-sand-charcoal',
  themes: PRESET_THEMES,
  cart: [],
  orders: [], // Added
  isCartOpen: false,
  config: {
    primaryColor: '#1f1f1f',
    secondaryColor: '#d6cec5',
    companyName: 'Hydro Atelier',
    companyTagline: 'Pure Water Essence',
    contactEmail: 'kontakt@hydroatelier.pl',
    contactPhone: '+48 22 000 00 00',
    address: 'Mokotowska 1, Warszawa',
    logoUrl: '',
    faviconUrl: '',
    facebookUrl: '',
    googleMapsUrl: '',
    showCelebrationBanner: false,
    googleAnalyticsId: '',
    payuPosId: '',
    payuClientSecret: '',
    payuMd5Key: '',
    payuEnv: 'sandbox',
    baseLinkerToken: ''
  },
  pages: [
    {
      id: 'home',
      slug: '/',
      title: 'Home',
      metaDescription: 'Hydro Atelier - Ekskluzywne systemy uzdatniania wody dla Twojego domu.',
      sections: [
        {
          id: 'hero-shop',
          type: SectionType.HERO,
          title: 'Esencja Czystości',
          subtitle: 'Luksusowe systemy uzdatniania wody, które harmonijnie wpisują się w Twoje wnętrze.',
          buttonText: 'Odkryj Kolekcję',
          buttonLink: '/kolekcja',
          imageUrl: HOME_WATER_IMAGES[0],
          isAutoRotationEnabled: true,
          rotationMode: 'timer',
          rotationInterval: 8,
          galleryImages: HOME_WATER_IMAGES
        },
        {
          id: 'shop-products-bestsellers',
          type: SectionType.PRODUCT_GRID,
          title: 'Wyselekcjonowane',
          subtitle: 'Ponadczasowy design i bezkompromisowa jakość.',
          items: [
            { 
              id: 'prod-carbon-7',
              title: 'Carbon Softener Series 7', 
              description: 'Minimalistyczny zmiękczacz wody z systemem WiFi.', 
              price: '4200',
              purchasePrice: '2800', 
              basePrice: '4200',
              badge: 'Signature',
              imageUrl: 'https://images.unsplash.com/photo-1565514020176-db7933b942bc?q=80&w=2570&auto=format&fit=crop',
              longDescription: 'Flagowy model marki Hydro Atelier. Połączenie zaawansowanej żywicy jonowymiennej z węglem aktywnym zapewnia wodę nie tylko miękką, ale i pozbawioną chloru oraz metali ciężkich. Sterowanie smartfonem pozwala monitorować zużycie wody w czasie rzeczywistym.',
              attributes: { 'function': 'Zmiękczanie + Węgiel', 'capacity': '25L' },
              variants: [
                  { id: 'v1', name: 'Wersja Standard (25L)', price: '4200', purchasePrice: '2800', available: true },
                  { id: 'v2', name: 'Wersja XL (35L)', price: '4800', purchasePrice: '3200', available: true }
              ]
            },
            { 
              id: 'prod-tap-matte',
              title: 'Purity Tap Matte Black', 
              description: 'Bateria kuchenna z systemem filtracji RO.', 
              price: '1800',
              purchasePrice: '1100',
              basePrice: '1800',
              imageUrl: 'https://images.unsplash.com/photo-1542013936693-884638332954?q=80&w=2670&auto=format&fit=crop',
              attributes: { 'finish': 'Czarny Mat', 'type': 'Trójdrożna' }
            },
            { 
              id: 'prod-crystal-carafe',
              title: 'Crystal Carafe Set', 
              description: 'Ręcznie formowane szkło z wkładem mineralizującym.', 
              price: '350',
              purchasePrice: '120',
              basePrice: '350',
              imageUrl: 'https://images.unsplash.com/photo-1540899805973-10e301297121?q=80&w=2574&auto=format&fit=crop'
            },
             { 
              id: 'prod-uv-shield',
              title: 'UV Shield Pro', 
              description: 'Niewidoczna ochrona biologiczna dla Twojego domu.', 
              price: '2100',
              purchasePrice: '1400',
              basePrice: '2400',
              oldPrice: '2400',
              imageUrl: 'https://images.unsplash.com/photo-1622300582998-3850dfd92d84?q=80&w=2670&auto=format&fit=crop'
            }
          ]
        },
        {
          id: 'cat-features',
          type: SectionType.FEATURES,
          title: 'Filozofia Marki',
          items: [
            { title: 'Harmonia', description: 'Technologia, która jest niewidoczna, ale odczuwalna w każdej kropli.', icon: 'Wind' },
            { title: 'Zdrowie', description: 'Woda pozbawiona zanieczyszczeń, bogata w minerały.', icon: 'Droplets' },
            { title: 'Ekologia', description: 'Rezygnacja z plastiku to najwyższa forma elegancji.', icon: 'Leaf' },
          ]
        },
        {
          id: 'cta-install',
          type: SectionType.CTA,
          title: 'Usługa Concierge',
          content: 'Zapewniamy pełną obsługę - od doboru urządzenia po profesjonalny montaż i serwis.',
          buttonText: 'Umów Konsultację',
          buttonLink: '/kontakt'
        }
      ]
    },
    {
      id: 'softeners',
      slug: '/kolekcja',
      title: 'Kolekcja',
      metaDescription: 'Kolekcja zmiękczaczy wody Hydro Atelier.',
      sections: [
        {
           id: 'soft-hero',
           type: SectionType.HERO,
           title: 'The Collection',
           subtitle: 'Odkryj kompletne rozwiązania dla Twojego domu.',
           imageUrl: 'https://images.unsplash.com/photo-1584622050111-993a426fbf0a?q=80&w=2670&auto=format&fit=crop'
        },
        // Group 1: Softeners
        {
           id: 'soft-prod-1',
           type: SectionType.PRODUCT_GRID,
           title: 'Zmiękczacze Wody',
           subtitle: 'Poczuj aksamitną miękkość wody. Ochrona dla Twojej skóry i urządzeń.',
           filterCategories: [
               { key: 'users', label: 'Liczba Osób' },
               { key: 'capacity', label: 'Pojemność Złoża' },
               { key: 'wifi', label: 'WiFi / Smart' }
           ],
           items: [
             {
               id: 'hydro-slim',
               title: 'Hydro Slim',
               description: 'Dyskretny luksus do apartamentów. Mieści się w każdej szafce.',
               price: '3200',
               imageUrl: 'https://images.unsplash.com/photo-1565514020176-db7933b942bc?q=80&w=2570&auto=format&fit=crop',
               attributes: { 'users': '1-3', 'capacity': '10L', 'wifi': 'Nie' }
             },
             {
               id: 'hydro-estate',
               title: 'Hydro Estate',
               description: 'Bezkompromisowa wydajność dla dużych rezydencji.',
               price: '4800',
               badge: 'Bestseller',
               imageUrl: 'https://images.unsplash.com/photo-1565514020176-db7933b942bc?q=80&w=2570&auto=format&fit=crop',
               attributes: { 'users': '4-8', 'capacity': '30L', 'wifi': 'Tak' }
             },
             {
                id: 'carbon-series',
                title: 'Carbon Series',
                description: 'Połączenie zmiękczania z filtracją węglową.',
                price: '5200',
                imageUrl: 'https://images.unsplash.com/photo-1565514020176-db7933b942bc?q=80&w=2570&auto=format&fit=crop',
                attributes: { 'users': '3-6', 'capacity': '25L', 'wifi': 'Tak' }
             }
           ]
        },
        // Group 2: RO / Kitchen
        {
            id: 'soft-prod-2',
            type: SectionType.PRODUCT_GRID,
            title: 'Systemy Kuchenne',
            subtitle: 'Krystaliczna woda prosto z Twojego kranu.',
            filterCategories: [
                { key: 'finish', label: 'Wykończenie' },
                { key: 'type', label: 'Typ Systemu' }
            ],
            items: [
              {
                id: 'purity-tap-gold',
                title: 'Purity Tap Gold',
                description: 'Bateria trójdrożna w wykończeniu szczotkowanego złota.',
                price: '1950',
                imageUrl: 'https://images.unsplash.com/photo-1542013936693-884638332954?q=80&w=2670&auto=format&fit=crop',
                attributes: { 'finish': 'Złoto Szczotkowane', 'type': 'Bateria Trójdrożna' }
              },
              {
                id: 'ro-7-mineral',
                title: 'RO-7 Mineral',
                description: '7-stopniowa filtracja z mineralizacją dolomitową.',
                price: '1200',
                imageUrl: 'https://images.unsplash.com/photo-1542013936693-884638332954?q=80&w=2670&auto=format&fit=crop',
                attributes: { 'finish': 'N/A', 'type': 'Podzlewowy' }
              }
            ]
         },
         // Group 3: Accessories
         {
            id: 'soft-prod-3',
            type: SectionType.PRODUCT_GRID,
            title: 'Akcesoria i Serwis',
            subtitle: 'Elementy eksploatacyjne i dodatki.',
            items: [
              {
                id: 'salt-tabs',
                title: 'Sól Tabletkowana',
                description: 'Najwyższej czystości sól do regeneracji złóż.',
                price: '45',
                imageUrl: 'https://images.unsplash.com/photo-1615631648086-325cd3d0f381?q=80&w=2670&auto=format&fit=crop'
              },
              {
                id: 'filters-set',
                title: 'Zestaw Wkładów Roczny',
                description: 'Komplet filtrów wstępnych i węglowych.',
                price: '120',
                imageUrl: 'https://images.unsplash.com/photo-1585837575652-2c6bf86aa34c?q=80&w=2670&auto=format&fit=crop'
              }
            ]
         }
      ]
    },
    {
      id: 'contact',
      slug: '/kontakt',
      title: 'Kontakt',
      metaDescription: 'Skontaktuj się z Hydro Atelier.',
      sections: [
        {
          id: 'contact-info',
          type: SectionType.TEXT_IMAGE,
          title: 'Biuro Hydro Atelier',
          content: 'Zapraszamy do kontaktu z naszym zespołem ekspertów.\n\nWarszawa, ul. Mokotowska 1\npon-pt: 10:00 - 18:00',
          imageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2301&auto=format&fit=crop',
          buttonText: 'Napisz Email',
          buttonLink: 'mailto:kontakt@hydroatelier.pl'
        }
      ]
    },
    {
        id: 'terms',
        slug: '/regulamin',
        title: 'Regulamin',
        metaDescription: 'Regulamin sklepu internetowego Hydro Atelier (Envicon Polska)',
        sections: [
            {
                id: 'terms-content',
                type: SectionType.RICH_TEXT,
                title: 'Regulamin Sklepu Internetowego',
                subtitle: 'Obowiązuje od dnia 01.01.2024',
                content: `I. POSTANOWIENIA OGÓLNE
1. Sklep internetowy działający pod adresem strony internetowej jest prowadzony przez firmę Envicon Polska Sp. z o.o. z siedzibą w Gdyni, wpisaną do rejestru przedsiębiorców.
2. Regulamin określa zasady zawierania umów sprzedaży za pośrednictwem sklepu internetowego, zasady wykonywania tych umów oraz zasady postępowania reklamacyjnego.

II. USŁUGI ELEKTRONICZNE
1. Sprzedawca świadczy za pośrednictwem Sklepu usługi elektroniczne polegające na umożliwieniu Klientom składania zamówień (koszyk) oraz przeglądania treści.
2. Korzystanie ze Sklepu jest dobrowolne i bezpłatne.

III. WARUNKI ZAWIERANIA UMOWY SPRZEDAŻY
1. Informacje o Towarach podane na stronach internetowych Sklepu, w szczególności ich opisy, parametry techniczne i użytkowe oraz ceny, stanowią zaproszenie do zawarcia umowy.
2. Wszystkie ceny w sklepie są cenami brutto (zawierają podatek VAT).
3. Warunkiem złożenia zamówienia jest akceptacja Regulaminu.

IV. PŁATNOŚCI I DOSTAWA
1. Klient ma możliwość zapłaty za zamówienie za pośrednictwem szybkich płatności online (PayU / Przelewy24).
2. Dostawa realizowana jest na terytorium Rzeczypospolitej Polskiej.
3. Koszty dostawy są wskazywane w momencie składania zamówienia.

V. REKLAMACJA I ZWROTY
1. Sprzedawca jest zobowiązany dostarczyć towar wolny od wad.
2. Konsument ma prawo odstąpić od umowy zawartej na odległość w terminie 14 dni bez podania przyczyny.
3. Aby skorzystać z prawa odstąpienia od umowy, Konsument musi poinformować Sprzedawcę o swojej decyzji w drodze jednoznacznego oświadczenia.

VI. OCHRONA DANYCH OSOBOWYCH
1. Administratorem danych osobowych jest Sprzedawca.
2. Szczegóły dotyczące przetwarzania danych znajdują się w Polityce Prywatności.`
            }
        ]
    },
    {
        id: 'privacy',
        slug: '/polityka-prywatnosci',
        title: 'Polityka Prywatności',
        metaDescription: 'Zasady przetwarzania danych osobowych RODO.',
        sections: [
            {
                id: 'privacy-content',
                type: SectionType.RICH_TEXT,
                title: 'Polityka Prywatności i Plików Cookies',
                subtitle: 'Zgodnie z RODO',
                content: `1. Administrator Danych
Administratorem Państwa danych osobowych jest Envicon Polska Sp. z o.o. Z administratorem można skontaktować się pisemnie, za pomocą poczty tradycyjnej na adres siedziby lub mailowo.

2. Cele Przetwarzania
Państwa dane osobowe przetwarzane są w celach:
a) realizacji umowy sprzedaży lub podjęcia działań przed jej zawarciem (zamówienia),
b) realizacji obowiązków prawnych ciążących na Administratorze (faktury, księgowość),
c) marketingu bezpośredniego własnych produktów lub usług.

3. Odbiorcy Danych
Odbiorcami Państwa danych mogą być podmioty realizujące dostawę (firmy kurierskie, InPost), operatorzy płatności (PayU) oraz biuro księgowe.

4. Okres Przechowywania
Dane będą przechowywane przez okres niezbędny do realizacji umowy, a po tym czasie przez okres wymagany przepisami prawa podatkowego.

5. Prawa Użytkownika
Posiadają Państwo prawo dostępu do treści swoich danych oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych oraz prawo wniesienia sprzeciwu.

6. Pliki Cookies
Sklep wykorzystuje pliki cookies w celu zapewnienia poprawnego działania strony, zapamiętania zawartości koszyka oraz w celach analitycznych. Mogą Państwo w każdej chwili zmienić ustawienia dotyczące cookies w swojej przeglądarce.`
            }
        ]
    }
  ]
};

const mergeState = (loaded: AppState | undefined): AppState => {
  if (!loaded) return DEFAULT_STATE;
  return {
    ...DEFAULT_STATE,
    ...loaded,
    themes: loaded.themes || DEFAULT_STATE.themes,
    currentThemeId: loaded.currentThemeId || DEFAULT_STATE.currentThemeId,
    viewMode: loaded.viewMode || DEFAULT_STATE.viewMode,
    cart: loaded.cart || [],
    orders: loaded.orders || [],
    isCartOpen: false,
    config: {
        ...DEFAULT_STATE.config,
        ...loaded.config,
        // Ensure PayU defaults are set if loading old state
        payuPosId: loaded.config.payuPosId || '',
        payuClientSecret: loaded.config.payuClientSecret || '',
        payuMd5Key: loaded.config.payuMd5Key || '',
        payuEnv: loaded.config.payuEnv || 'sandbox',
        baseLinkerToken: loaded.config.baseLinkerToken || ''
    },
    pages: loaded.pages.map(p => ({
        ...p,
        sections: p.sections.map(s => ({
            ...s,
            galleryImages: s.galleryImages || (s.type === SectionType.HERO ? [s.imageUrl || ''] : []),
            isAutoRotationEnabled: s.isAutoRotationEnabled ?? false,
            rotationMode: s.rotationMode || 'timer',
            rotationInterval: s.rotationInterval || 5,
            items: s.items?.map(item => ({
                ...item,
                id: item.id || `gen-${Math.random().toString(36).substr(2, 9)}`, // Ensure legacy items have IDs
                variants: item.variants || [],
                attributes: item.attributes || {}
            }))
        }))
    }))
  };
};

export const INITIAL_STATE: AppState = mergeState(preloadedState);